<div class="public-form-page">

    <div class="form-container">
  
      <div class="form-header">
  
        <div class="form-icon">
          🏷️
        </div>
  
        <div>
          <span class="form-label">
            ABAQ
          </span>
  
          <h1>
            Placa de identificación
          </h1>
  
          <p>
            Completa la siguiente información para solicitar
            una placa de identificación para tu mascota.
          </p>
        </div>
  
      </div>
  
      @if (!submitted) {
  
        <form
          class="form-card"
          (ngSubmit)="submitForm()"
        >

<div class="section-title">
    <h2>
      Información del estudiante
    </h2>
  
    <p>
      Indica el nombre del estudiante de Servicio Social que te compartió este formulario.
    </p>
  </div>
  
  <div class="form-group">
    <label>
      Estudiante que compartió el formulario
    </label>
  
    <input
      type="text"
      name="linkerName"
      [(ngModel)]="linkerName"
      placeholder="Nombre completo del estudiante"
      required
    />
  </div>
  
          <div class="section-title">
            <h2>
              Información del responsable
            </h2>
  
            <p>
              Datos de contacto de la persona responsable.
            </p>
          </div>
  
          <div class="form-grid">
  
            <div class="form-group">
              <label>
                Nombre del responsable
              </label>
  
              <input
                type="text"
                name="responsibleName"
                [(ngModel)]="responsibleName"
                placeholder="Nombre completo"
                required
              />
            </div>
  
            <div class="form-group">
              <label>
                Teléfono
              </label>
  
              <input
                type="tel"
                name="phone"
                [(ngModel)]="phone"
                placeholder="Número de teléfono"
                required
              />
            </div>
  
          </div>
  
          <div class="section-title">
            <h2>
              Información de la mascota
            </h2>
  
            <p>
              Datos necesarios para la elaboración de la placa.
            </p>
          </div>
  
          <div class="form-grid">
  
            <div class="form-group">
              <label>
                Especie
              </label>
  
              <select
                name="species"
                [(ngModel)]="species"
              >
                <option value="DOG">
                  Perro
                </option>
  
                <option value="CAT">
                  Gato
                </option>
              </select>
            </div>
  
            <div class="form-group">
              <label>
                Nombre del animal
              </label>
  
              <input
                type="text"
                name="animalName"
                [(ngModel)]="animalName"
                placeholder="Nombre de la mascota"
                required
              />
            </div>
  
          </div>
  
          <div class="section-title">
            <h2>
              Características de la placa
            </h2>
  
            <p>
              Indica las características de la placa solicitada.
            </p>
          </div>
  
          <div class="form-grid">
  
            <div class="form-group">
              <label>
                Diseño
              </label>
  
              <input
                type="text"
                name="plateDesign"
                [(ngModel)]="plateDesign"
                placeholder="Diseño solicitado"
              />
            </div>
  
            <div class="form-group">
              <label>
                Material
              </label>
  
              <select
                name="material"
                [(ngModel)]="material"
              >
                <option value="STEEL">
                  Acero
                </option>
  
                <option value="ALUMINUM">
                  Aluminio
                </option>
              </select>
            </div>
  
          </div>
  
          <div class="section-title">
            <h2>
              Comprobante de pago
            </h2>
  
            <p>
              Si cuentas con un enlace al comprobante,
              puedes agregarlo aquí.
            </p>
          </div>
  
          <div class="form-group">
  
            <label>
              Enlace del comprobante
            </label>
  
            <input
              type="url"
              name="paymentProofUrl"
              [(ngModel)]="paymentProofUrl"
              placeholder="https://..."
            />
  
          </div>
  
          <div class="form-actions">
  
            <button
              type="submit"
              [disabled]="isSubmitting"
            >
              @if (isSubmitting) {
                Enviando...
              } @else {
                Enviar solicitud
              }
            </button>
  
          </div>
  
        </form>
  
      } @else {
  
        <div class="success-card">
  
          <div class="success-icon">
            ✓
          </div>
  
          <h2>
            Solicitud enviada correctamente
          </h2>
  
          <p>
            Hemos recibido la información de la placa.
            ABAQ revisará los datos y dará seguimiento
            a la solicitud.
          </p>
  
        </div>
  
      }
  
    </div>
  
  </div>